<template>
  <div>
    <v-row no-gutters class="mb-3">
      <div class="d-flex">
        <strong class="mt-2">エピソード制限: </strong>
        <strong class="ml-2 mt-2" v-text="maxEpisode" />
      </div>
      <v-spacer />
      <!-- Dialog select show chapter -->
      <v-dialog v-model="dialogSelectShowChapter" persistent max-width="380">
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="primary" small class="mr-0" v-bind="attrs" v-on="on"
            >エピソード制限解除</v-btn
          >
        </template>
        <v-card>
          <v-card-title class="headline mb-3">
            エピソード制限の変更
          </v-card-title>
          <v-card-text class="d-flex">
            <!-- Select chapter release -->
            <strong class="mt-2">エピソード制限: </strong>
            <v-select
              :items="chapters"
              item-text="text"
              item-value="key"
              hide-details
              class="v-select-chapter"
              dense
              outlined
              v-model="chapterSelect"
            ></v-select>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              small
              @click="showDialogConfirmChapter"
              :disabled="
                !chapterSelect ||
                loadingApproveChapter ||
                chapterSelect == masterData.max_episode
              "
              >解除</v-btn
            >
            <v-btn color @click="dialogSelectShowChapter = false" small
              >キャンセル</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Dialog comfirm release -->
      <v-dialog v-model="dialogComfirmChapter" persistent max-width="370">
        <v-card>
          <v-card-title class="headline"> 確認 </v-card-title>
          <v-card-text class="pb-0"
            >{{ maxEpisodeSelect }}まで解除します。よろしいですか。</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              small
              @click="approveChapter"
              :loading="loadingApproveChapter"
              :disabled="loadingApproveChapter"
              >OK</v-btn
            >
            <v-btn color @click="cancelConfirm" small>キャンセル</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row class="mb-2" no-gutters>
      <template v-if="masterData.active_version != '0.0.0'">
        <v-col>
          <div class="d-flex">
            <strong> 現在のバージョン </strong>
            <p class="ml-2">
              {{ masterData.active_version }}
            </p>
          </div>
        </v-col>
        <v-col>
          <div class="d-flex">
            <strong style="min-width: 80px !important"> 公開日 </strong>
            <p class="ml-2 min-width-2" >
              {{approvedAt}}
              <!-- {{ $moment(masterData.approved_at).format("YYYY/MM/DD HH:mm") }} -->
            </p>
          </div>
        </v-col>
      </template>
      <template v-else>
        <v-col class="pt-1">
          <strong>現在のバージョン：未公開</strong>
        </v-col>
      </template>

      <!-- Dialog comfirm release -->
      <v-dialog v-model="dialogComfirm" persistent max-width="370">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            small
            class="mr-0"
            :disabled="masterData.release !== 'WAITING' || loadingApprove"
            v-bind="attrs"
            v-on="on"
            >リリース承認</v-btn
          >
        </template>
        <v-card>
          <v-card-title class="headline"> 確認 </v-card-title>
          <v-card-text class="pb-0">承認します。よろしいですか</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              small
              @click="approveExportData"
              :loading="loadingApprove"
              :disabled="loadingApprove"
              >OK</v-btn
            >
            <v-btn color @click="dialogComfirm = false" small>キャンセル</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row no-gutters>
      <v-data-table
        :headers="headers"
        :items="masterHistory"
        :loading="loadingMasterData"
        loading-text="読み込み中。。。待ってください。"
        hide-default-footer
        item-key="Id"
        class="elevation-1 width-10"
      >
        <template v-slot:item.release="{ item }">
          <v-chip small :color="colorStatus(item.release)" dark>{{
            textStatus(item.release)
          }}</v-chip>
        </template>
        <template v-slot:item.released_at="{ item }">
          {{
            item.released_at
              ? $moment(item.released_at).format("YYYY/MM/DD HH:mm")
              : ""
          }}
        </template>
        <template v-slot:item.approved_at="{ item }">
          {{
            item.approved_at
              ? $moment(item.approved_at).format("YYYY/MM/DD HH:mm")
              : ""
          }}
        </template>
        <template v-slot:item.actions="{ item: { Id } }">
          <DialogDetailVersion :itemId="Id" />
        </template>
        <template v-slot:no-data>
          <div class="text-center">データがありません。</div>
        </template>
      </v-data-table>
    </v-row>
  </div>
</template>
<script>
import {
  getHistoryMaster,
  exportData,
  getMasterData,
  UpdateSettingChapter,
} from "@/api/MasterData.api";
import DialogDetailVersion from "./DialogDetailVersion";
export default {
  components: { DialogDetailVersion },
  data() {
    return {
      masterData: {},
      masterHistory: [],
      loadingMasterData: false,
      loadingApprove: false,
      dialogComfirm: false,
      dialogSelectShowChapter: false,
      dialogComfirmChapter: false,
      loadingApproveChapter: false,
      headers: [
        {
          text: "バージョン",

          value: "release_version",
          sortable: false,
        },
        {
          text: "ステータス",
          value: "release",
          sortable: false,
        },
        {
          text: "依頼日",
          value: "released_at",
          sortable: false,
        },
        {
          text: "公開日",
          value: "approved_at",
          sortable: false,
        },
        { text: "", value: "actions", align: "end" },
      ],
      chapters: [
        { text: "エピソード 1", key: 1 },
        { text: "エピソード 2", key: 2 },
        { text: "エピソード 3", key: 3 },
        { text: "エピソード 4", key: 4 },
        { text: "エピソード 5", key: 5 },
        { text: "エピソード 6", key: 6 },
        { text: "エピソード 7", key: 7 },
        { text: "エピソード 8", key: 8 },
        { text: "エピソード 9", key: 9 },
        { text: "エピソード 10", key: 10 },
        { text: "エピソード 11", key: 11 },
        { text: "エピソード 12", key: 12 },
        { text: "エピソード 13", key: 13 },
        { text: "エピソード 14", key: 14 },
        { text: "エピソード 15", key: 15 },
        { text: "エピソード 16", key: 16 },
        { text: "シーズン1まとめ", key: 17 },
        { text: "エピソード 17", key: 18 },
        { text: "エピソード 18", key: 19 },
        { text: "エピソード 19", key: 20 },
        { text: "エピソード 20", key: 21 },
        { text: "エピソード 21", key: 22 },
        { text: "エピソード 22", key: 23 },
        { text: "エピソード 23", key: 24 },
        { text: "エピソード 24", key: 25 },
        { text: "エピソード 25", key: 26 },
        { text: "エピソード 26", key: 27 },
        { text: "エピソード 27", key: 28 },
        { text: "エピソード 28", key: 29 },
        { text: "エピソード 29", key: 30 },
        { text: "エピソード 30", key: 31 },
        { text: "エピソード 31", key: 32 },
        { text: "エピソード 32", key: 33 },
        { text: "シーズン2まとめ", key: 34 },
      ],
      chapterSelect: null,
    };
  },
  mounted() {
    this.getMasterData();
    this.getHistoryMaster();
  },
  computed: {
    maxEpisode: function () {
      const {
        chapters,
        masterData: { max_episode },
      } = this;
      let find = chapters.find((i) => i.key == max_episode);
      if (find) {
        return find.text;
      }
      return "";
    },
    maxEpisodeSelect: function () {
      const { chapters, chapterSelect } = this;
      let find = chapters.find((i) => i.key == chapterSelect);
      if (find) {
        return find.text;
      }
      return "";
    },
    approvedAt : function(){
      const { masterHistory, _ } = this
      const { active_version } = this.masterData
      let version = _.find(masterHistory, e => e.active_version == active_version && e.release == "APROVED")
      if(version) return this.$moment(version.approved_at).format("YYYY/MM/DD HH:mm");
      return ""
    }
  },
  watch: {
    dialogSelectShowChapter: function (val) {
      if (val) {
        const {
          masterData: { max_episode },
        } = this;
        this.chapterSelect = max_episode;
      }
    },
  },
  methods: {
    async approveExportData() {
      const { Id } = this.masterData;
      this.loadingApprove = true;
      await exportData({ id: Id })
        .then(async () => {
          await this.getMasterData();
          await this.getHistoryMaster();
          this.loadingApprove = false;
          this.dialogComfirm = false;
        })
        .catch(async (error) => {
          if (error.response.data.result.error == "RELEASE_INPROGRESS") {
            this.$toast.error(
              "コンテンツはまだ準備中です。\n少々お待ちください。"
            );
          }
          await this.getMasterData();
          await this.getHistoryMaster();
          this.loadingApprove = false;
        });
    },
    colorStatus(status) {
      if (status == "WAITING" || status == "WAITING_RELEASE") {
        return "warning";
      } else if (status == "CREATED") {
        return "primary";
      } else if (status == "PENDING") {
        return "indigo";
      } else if (status == "APROVED") {
        return "success";
      }
    },
    textStatus(status) {
      if (status == "WAITING") {
        return "承認待ち";
      } else if (status == "CREATED") {
        return "作成済";
      } else if (status == "PENDING") {
        return "編集中";
      } else if (status == "APROVED") {
        return "承認";
      } else if (status == "WAITING_RELEASE") {
        return "処理中";
      }
    },
    getMasterData: async function () {
      await getMasterData().then(({ result }) => {
        this.masterData = result;
        this.chapterSelect = result.max_episode;
      });
    },
    getHistoryMaster: async function () {
      const { _ } = this;
      this.loadingMasterData = true;
      await getHistoryMaster().then(({ result }) => {
        this.masterHistory = _.filter(result, function (o) {
          return o.release !== "PENDING" && o.release_version !== "0.0.0";
        });
      });
      this.loadingMasterData = false;
    },
    approveChapter: async function () {
      this.loadingApproveChapter = true;
      await UpdateSettingChapter({
        max_episode: this.chapterSelect,
      })
        .then(() => {
          this.getMasterData();
          this.chapterSelect = null;
          this.loadingApproveChapter = false;
          this.dialogComfirmChapter = false;
        })
        .catch(() => (this.loadingApproveChapter = false));
    },
    showDialogConfirmChapter: function () {
      this.dialogSelectShowChapter = false;
      this.dialogComfirmChapter = true;
    },
    cancelConfirm: function () {
      this.dialogComfirmChapter = false;
      this.dialogSelectShowChapter = true;
    },
  },
};
</script>
<style scoped>
strong {
  min-width: 130px;
}
.v-select-chapter {
  min-width: 187px;
  max-width: 187px;
}
::v-deep td:not(:last-child),
th:not(:last-child) {
  border-right: none !important;
}
::v-deep .v-data-table tbody tr.v-data-table__expanded__content {
  box-shadow: none;
}
::v-deep thead.v-data-table-header {
  background: #eeeeee;
}
</style>